

























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment";
import { SupportContent } from "@/http/api/v2/supporter/content";
import { SupportContentSummaryDto, SupportNoticeDto } from "@/http/dto/supportContent";

const HotelModule = namespace("HotelModule");

@Component
export default class NoticeManagement extends Vue {
  @HotelModule.State("hotelObjectId") hotelObjectId!: string;

  periodDays = 30;
  category = "";
  keyword = "";
  current = 1;
  total = 0;
  loading = false;
  errorMessage = "";
  data: SupportNoticeDto[] = [];
  summary: SupportContentSummaryDto = { todayTotal: 0, periodTotal: 0, activeHotelTotal: 0 };
  detailVisible = false;
  detailLoading = false;
  detail: SupportNoticeDto | null = null;

  get hotelObjectIdValue() { return this.hotelObjectId; }

  @Watch("hotelObjectIdValue")
  hotelObjectIdChanged() { this.current = 1; this.load(); }

  get periodText() { return this.periodDays === 0 ? "전체 기간" : `최근 ${this.periodDays}일`; }

  get pagination() {
    return {
      total: this.total,
      pageSize: 20,
      current: this.current,
      showTotal: (total: number) => `총 ${this.number(total)}개`,
      showSizeChanger: false,
    };
  }

  get columns() {
    return [
      { title: "호텔", dataIndex: "hotel", width: 210, fixed: "left", scopedSlots: { customRender: "hotel" } },
      { title: "게시글", dataIndex: "content", width: 480, scopedSlots: { customRender: "content" } },
      { title: "작성자", dataIndex: "writer", width: 170, scopedSlots: { customRender: "writer" } },
      { title: "활동", dataIndex: "activity", width: 140, scopedSlots: { customRender: "activity" } },
      { title: "작성일", dataIndex: "createdTime", width: 150, scopedSlots: { customRender: "date" } },
      { title: "보기", dataIndex: "detail", width: 100, fixed: "right", scopedSlots: { customRender: "detail" } },
    ];
  }

  mounted() { this.load(); }
  number(value: number) { return Number(value || 0).toLocaleString("ko-KR"); }
  dateTime(value: string) { return moment(value).format("YYYY.MM.DD HH:mm"); }

  relativeTime(value: string) {
    const days = moment().diff(moment(value), "days");
    if (days < 1) return "오늘";
    if (days < 30) return `${days}일 전`;
    return moment(value).format("YYYY.MM.DD");
  }

  formatBytes(value: number) {
    const bytes = Number(value || 0);
    if (!bytes) return "0 B";
    const units = ["B", "KB", "MB", "GB"];
    const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    return `${(bytes / Math.pow(1024, index)).toFixed(index === 0 ? 0 : 1)} ${units[index]}`;
  }

  changeFilter() { this.current = 1; this.load(); }
  search() { this.current = 1; this.load(); }

  async load(pagination?: any) {
    try {
      this.loading = true;
      this.errorMessage = "";
      const current = pagination && pagination.current ? pagination.current : this.current;
      const result = await SupportContent.getNotices({
        page: current,
        take: 20,
        periodDays: this.periodDays,
        keyword: this.keyword || undefined,
        category: this.category || undefined,
        hotelObjectId: this.hotelObjectId || undefined,
      });
      this.current = result.page;
      this.total = result.total;
      this.summary = result.summary;
      this.data = result.items;
    } catch (error) {
      this.errorMessage = "게시글 운영 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
    } finally {
      this.loading = false;
    }
  }

  async openDetail(objectId: string) {
    this.detailVisible = true;
    this.detailLoading = true;
    this.detail = null;
    try {
      this.detail = await SupportContent.getNotice(objectId);
    } catch (error) {
      this.$message.error("게시글 상세 정보를 불러오지 못했습니다.");
      this.detailVisible = false;
    } finally {
      this.detailLoading = false;
    }
  }

  closeDetail() { this.detailVisible = false; this.detail = null; }
}
